import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, TwitterIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-800 text-white py-12" data-id="element-13">
      <div className="container mx-auto px-4" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-15">
          <div data-id="element-16">
            <h3 className="text-lg font-bold mb-4" data-id="element-17">MoveEst</h3>
            <p className="text-gray-300 mb-4" data-id="element-18">
              Professional moving services across Estonia. We make your move
              stress-free.
            </p>
            <div className="flex space-x-4" data-id="element-19">
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-20">
                <FacebookIcon size={20} data-id="element-21" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-22">
                <InstagramIcon size={20} data-id="element-23" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-24">
                <TwitterIcon size={20} data-id="element-25" />
              </a>
            </div>
          </div>
          <div data-id="element-26">
            <h3 className="text-lg font-bold mb-4" data-id="element-27">Quick Links</h3>
            <ul className="space-y-2" data-id="element-28">
              <li data-id="element-29">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-30">
                  Home
                </Link>
              </li>
              <li data-id="element-31">
                <Link to="/order" className="text-gray-300 hover:text-white" data-id="element-32">
                  Book a Move
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/tracking" className="text-gray-300 hover:text-white" data-id="element-34">
                  Track Order
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-36">
                  Services
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-38">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-39">
            <h3 className="text-lg font-bold mb-4" data-id="element-40">Contact Us</h3>
            <div className="space-y-3" data-id="element-41">
              <div className="flex items-start" data-id="element-42">
                <MapPinIcon size={20} className="mr-2 mt-1 flex-shrink-0" data-id="element-43" />
                <span data-id="element-44">Tallinn, Estonia</span>
              </div>
              <div className="flex items-center" data-id="element-45">
                <PhoneIcon size={20} className="mr-2 flex-shrink-0" data-id="element-46" />
                <span data-id="element-47">+372 555 1234</span>
              </div>
              <div className="flex items-center" data-id="element-48">
                <MailIcon size={20} className="mr-2 flex-shrink-0" data-id="element-49" />
                <span data-id="element-50">info@moveest.ee</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400 text-sm" data-id="element-51">
          <p data-id="element-52">&copy; {new Date().getFullYear()} MoveEst. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};